import { CommandStep, GroupStep } from "app/lib/pipeline";
import { twMerge } from "tailwind-merge";
import { bgColorForStep } from "app/components/Playground/Node/colors";
import JobGroup from "app/components/build/Header/pipeline/utils/jobGroup";
import { Job } from "app/components/build/Show/lib/types";

// Given an array of jobs, display a count of the number of passed jobs in that group.
// This is useful for parallel, matrix and group steps.
export const JobCount = ({ jobs, step }: { jobs: Array<Job>; step: CommandStep | GroupStep }) => {
  const jobGroup = new JobGroup(step.uuid);

  for (const job of jobs) {
    jobGroup.appendJob(job);
  }

  return (
    <span
      className={twMerge(
        "rounded-[4px] border border-current px-1 text-charcoal-700",
        bgColorForStep(step),
        "bg-white",
      )}
    >
      {jobGroup.passedCount}/{jobGroup.total || jobGroup.jobs.length}
    </span>
  );
};
